export const isMobile = false
export const isStorybook = document.body.innerHTML.includes('class="sb-')
export const isCompiledForWeb = true
